import classNames from 'classnames'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import * as Styles from './contact.module.scss'
import { PRIVACY_POLICY_URL } from '@/constants/url'
import { pagesPath } from '@/lib/pagesPath'

export function Contact(props) {
  return (
    <section {...props} className={classNames(Styles.contact, props.className)}>
      <div className={Styles.bgPc}>
        <StaticImage
          src="../../images/contact_image_bg.png"
          width={2200}
          height={420}
        />
      </div>
      <div className={Styles.bgSp}>
        <StaticImage
          src="../../images/contact_image_bg-sp.png"
          width={420}
          height={442}
        />
      </div>
      <div className={Styles.contact__title_pc}>
        <p className={Styles.contact__title}>
          Uniforceで決算開示タスク管理の
          <br />
          <span className={Styles.contact__title__big}>「最短・最適ルート」</span>を
          <br />
          体験しませんか？
        </p>
      </div>
      <div className={Styles.contact__title_sp}>
        <p className={Styles.contact__title}>
          Uniforceで決算開示タスク管理の
          <br />
          <span>「最短・最適ルート」</span>を
          <br />
          体験しませんか？
        </p>
        <StaticImage
          src="../../images/contact_image_point-2.png"
          height={186}
        />
      </div>
      <div className={Styles.contact__mail}>
        <div className={Styles.contact__btn}>
          <AnchorLink to={pagesPath.demo.$url()}>サービス申込み</AnchorLink>
        </div>
        <div className={Styles.contact__btn_claim}>
          <AnchorLink to={pagesPath.download.$url()}>資料請求</AnchorLink>
        </div>
      </div>
      <p className={Styles.contact__attention}>
        Uniforceの
        <AnchorLink to={pagesPath.rule.$url()}>利用規約</AnchorLink>、
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
          プライバシーポリシー
        </a>
        に同意の上で、
        <br />
        登録ページにお進みください。
      </p>
    </section>
  )
}
